/**
 * @generated SignedSource<<7e611d03592a210b9307a6be1be74000>>
 * @relayHash a0b6281ad8328e2adece33059d7b499e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type HelpCenterSettingsRedirectOldQuery$variables = {
  cloudId: string;
  jiraProjectAri: string;
  jiraWorkspaceAri: string;
};
export type HelpCenterSettingsRedirectOldQuery$data = {
  readonly helpCenter: {
    readonly helpCenterByHoistedProjectIdRouted: {
      readonly __typename: "HelpCenter";
      readonly id: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type HelpCenterSettingsRedirectOldQuery = {
  response: HelpCenterSettingsRedirectOldQuery$data;
  variables: HelpCenterSettingsRedirectOldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraProjectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraWorkspaceAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "projectAri",
    "variableName": "jiraProjectAri"
  },
  {
    "kind": "Variable",
    "name": "workspaceAri",
    "variableName": "jiraWorkspaceAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "id"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "HelpCenter"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterSettingsRedirectOldQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "HelpCenterQueryApi",
          "kind": "LinkedField",
          "name": "helpCenter",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "helpCenterByHoistedProjectIdRouted",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "helpCenter.helpCenterByHoistedProjectIdRouted"
            }
          ]
        },
        "action": "THROW",
        "path": "helpCenter"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterSettingsRedirectOldQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterByHoistedProjectIdRouted",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "962b8856f333ff53b5c22613434dd482d1904e0e5e4341a8f7e1842d1be9743f",
    "metadata": {},
    "name": "HelpCenterSettingsRedirectOldQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b019fafdbfbfb9dc730e8f23eaf51dbd";

export default node;
